import type { MatterExternalSyncMappingPublicRead } from '@/user_files/external-storage/schemas'

type MappingOwnership = Pick<MatterExternalSyncMappingPublicRead, 'connected_by_user_id'>

/** Whether the current user connected this matter's DMS folder. */
export function isMatterSyncConnector(mapping: MappingOwnership | null | undefined, userId: string | null | undefined): boolean {
  return mapping != null && userId != null && mapping.connected_by_user_id === userId
}
